module.exports = __webpack_public_path__ + "img/leftarrow.5d33c853.svg";